export const SELECT_LEAD = 'SELECT_LEAD';